import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { ParcelaCobrancaJudicial } from '../domain/parcela-cobranca-judicial.model';

export class ParcelaCobrancaJudicialSerializer extends DomainSerializer<ParcelaCobrancaJudicial> {}
